import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A1E0EA60-79AF-42FD-966D-485276671F9C
 * name pentagon
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pentagon.svg
 * tags
 * - Shape 
 */
export const PentagonIcon = createSvgIcon(<><path d="M12,2.5L2,9.8L5.8,21.5H18.2L22,9.8L12,2.5Z" /></>, 'PentagonIcon');
export default PentagonIcon